<template>
	<div class="profile-wrapper">
		<div class="title">每日签到</div>
		<div class="calendar">
		    <div class="calendar-header">
		      <button @click="prevMonth"><i class="el-icon-arrow-left"></i></button>
		      <span>{{ currentYear }}年{{ currentMonth }}月</span>
		      <button @click="nextMonth"><i class="el-icon-arrow-right"></i></button>
			  <span class="jifen">
			  	<el-image :src="require('@/assets/golds.png')" fit="fill"></el-image>
			  	<span>当前积分：</span>
			  	<span class="jifenNum">{{total}}</span>
			  </span>
		    </div>
		    <div class="calendar-week-days">
		      <div v-for="day in weekDays" >{{ day }}</div>
		    </div>
		    <div class="calendar-days">
			  <div class="calendar-day null" v-for="item in dayOfWeek" :key="item"></div>
		      <div
		        v-for="(item,index) in days"
				class="calendar-day" 
				:class="new Date().getFullYear() > currentYear? 'before' :(new Date().getMonth() + 1 > currentMonth && new Date().getFullYear() == currentYear)?'before':(new Date().getMonth() + 1 == currentMonth&&index+1 < currentDay&& new Date().getFullYear() == currentYear)?'before':''"
		      >
		        <div class="day" :class="{'calendar-day-current': index == currentDay-1 && new Date().getMonth() + 1 == currentMonth}">{{ item.checkInDate.slice(-2) }}</div>
				<div class="ischecked" v-if="item.isCheckIn">已签到</div>
				<div v-else-if="!item.isCheckIn && index < currentDay-1&&new Date().getFullYear() <= currentYear&&new Date().getMonth() + 1 <= currentMonth">未签到</div>
				<div v-else><el-image class="icon-image" :src="require('@/assets/jifen.png')" fit="fill"></el-image>+100</div>
		      </div>
		    </div>
		</div>
		<div class="btn">
			<el-button type="warning" size="medium" round @click="signIn">立即签到</el-button>
		</div>
	</div>
</template>

<script>
import { commitCheckin,getCheckinrecord } from '@/api/personal/fuli'
import EventBus from '@/utils/eventHub.js'
export default {
  data () {
    return {
        currentYear: new Date().getFullYear(),
        currentMonth: new Date().getMonth() + 1,
        currentDay: new Date().getDate(),
        weekDays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        days: [],
		daysInMonth: 0,
		dayOfWeek: 0,
		total: 0
    }
  },
  methods: {
	  async getdays(){
	  	const res = await getCheckinrecord(this.currentYear,this.currentMonth)
	  	if (res.code === 0) {
	  		this.days = res.data
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  async signIn(){
	  	const res = await commitCheckin()
	  	if (res.code === 0) {
	  		this.$message.success('签到成功')
			this.getdays()
			EventBus.$emit('jifenChange', true)
			this.total = JSON.parse(localStorage.getItem('user')).integral
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
        prevMonth() {
          if (this.currentMonth === 1) {
            this.currentYear -= 1;
            this.currentMonth = 12;
          } else {
            this.currentMonth -= 1;
          }
          this.generateDays();
		  this.getdays()
        },
        nextMonth() {
          if (this.currentMonth === 12) {
            this.currentYear += 1;
            this.currentMonth = 1;
          } else {
            this.currentMonth += 1;
          }
          this.generateDays();
		  this.getdays()
        },
        generateDays() {
          this.daysInMonth = new Date(this.currentYear, this.currentMonth, 0).getDate();
          const firstDayOfMonth = new Date(this.currentYear, this.currentMonth - 1, 1);
          this.dayOfWeek = firstDayOfMonth.getDay();
          this.days = [];
        },
    },
    mounted() {
        this.generateDays();
		this.getdays()
		this.total = JSON.parse(localStorage.getItem('user')).integral
		EventBus.$on('getPoints', (result) => {
			this.total = result
		})
    },

}
</script>

<style lang="scss" scoped>
.profile-wrapper{
	padding: 30px 40px;
	.title{
		font-size: 20px;
		font-weight: 800;
		border-bottom: 1px solid #D4D4E6;
		padding-bottom: 10px;
	}
	.calendar {
	  width: 100%;
	  padding: 10px;
	}
	.calendar-header {
		margin: 10px 0 15px;
		
	  button{
		  background-color: #DDDDDD;
		  border: none;
		  border-radius: 50%;
		  color: #fff;
		  font-size: 18px;
		  font-weight: 800;
		  width: 24px;
		  height: 24px;
		  line-height: 24px;
		  text-align: center;
		  padding: 0;
		  &:first-child{
			  margin-right: 15px;
		  }
		  &:last-child{
			  margin-left: 15px;
		  }
	  }
	  span{
		  font-size: 20px;
		  font-weight: 800;
		  
	  }
	  .jifen{
	  	
	  	float: right;
	  			span{
	  				font-size: 14px;
	  				font-weight: 500;
	  			}
	  	.el-image{
	  		width: 35px;
	  		height: 25px;
	  		vertical-align: bottom;
	  	}
	  	.jifenNum{
	  		color: #313131;
	  		font-size: 20px;
	  		font-weight: 800;
	  	}
	  }
	}
	.calendar-week-days {
	  display: flex;
	}
	.calendar-week-days > div {
	  width: calc(100% / 7);
	  text-align: center;
	}
	.calendar-days {
	  display: flex;
	  flex-wrap: wrap;
	  gap: 10px;
	  margin-top: 10px;
	}
	.calendar-day {
	  width: calc((100% - 60px) / 7);
	  border: 1px solid #ddd;
	  text-align: center;
	  padding: 10px 5px;
	  box-sizing: border-box;
	  color: #949494;
	  font-size: 14px;
	  border-radius: 8px;
	  &.null{
		  border: none;
		  background-color: unset;
	  }
	  &.before{
		 background-color: #F8F8F8; 
	  }
	}
	.day{
		width: 28px;
		height: 28px;
		line-height: 28px;
		margin: 5px auto;
		font-size: 18px;
		font-weight: 800;
		color: #717171;
		margin-bottom: 10px;
	}
	.calendar-day-current {
		
	  background-color: #FF842E;
	  border-radius: 50%;
	  color: #fff;
	}
	.ischecked{
		color: #FF842E;
	}
	.icon-image{
		width: 20px;
		height: 20px;
		vertical-align: bottom;
	}
	.btn{
		margin-top: 30px;
		text-align: center;
		.el-button--warning{
			background-color: #FF842E;
		}
	}
}	

</style>